<template>
  <div class="min-h-screen bg-gray-50 text-slate-900 pb-24 overflow-x-hidden">
    <header
      class="relative bg-gradient-to-br from-orange-500 to-orange-400 pt-12 pb-28 px-6 rounded-b-3xl shadow-lg overflow-hidden"
    >
      <div
        class="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -mr-16 -mt-16 blur-3xl"
      ></div>

      <Bubble />
      <div class="relative z-10 flex flex-col items-center text-center">
        <div
          class="bg-white/20 backdrop-blur-sm p-2 rounded-full mb-3 shadow-inner"
        >
          <img
            class="w-14 h-14 object-contain drop-shadow-md"
            src="../assets/img/logo.webp"
            alt="Logo"
          />
        </div>
        <h1 class="text-white text-2xl font-black tracking-wider">NABELO</h1>
        <div>
          <span class="text-white text-md font-semibold">
            Layanan Digital Puskesmas Kota Palu
          </span>
        </div>
      </div>
    </header>

    <main class="relative z-30 max-w-4xl mx-auto px-5 -mt-12">
      <div class="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
        <div class="grid grid-cols-3 gap-y-8 gap-x-4">
          <div
            v-for="(menu, index) in menus"
            :key="index"
            class="flex flex-col items-center hover:scale-105 active:scale-95 transition-transform cursor-pointer"
            @click="handleMenuClick(menu)"
          >
            <div
              class="bg-white p-1 rounded-2xl mb-2 border border-orange-50 shadow-lg"
            >
              <img
                class="w-12 h-12 object-contain"
                :src="menu.image"
                :alt="menu.label"
              />
            </div>
            <div
              class="text-[11px] font-bold text-slate-600 text-center leading-tight"
            >
              <span v-html="menu.label.replace('<br>', ' ')"></span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-6 bg-orange-500 rounded-3xl p-5 flex items-center justify-between text-white shadow-lg"
      >
        <div class="pr-2">
          <h4 class="font-bold text-sm">Butuh Bantuan?</h4>
          <p class="text-[10px] opacity-80">
            Lihat panduan penggunaan aplikasi
          </p>
        </div>
        <button
          @click="openManual()"
          class="bg-white text-orange-500 px-4 py-2 rounded-xl text-xs font-bold whitespace-nowrap"
        >
          Lihat Panduan
        </button>
      </div>
    </main>

    <!-- <nav
      class="fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-gray-100 px-10 py-3 flex justify-between items-center z-50"
    >
      <div class="flex flex-col items-center text-orange-500">
        <span class="text-lg">🏠</span>
        <span class="text-[10px] font-bold">Home</span>
      </div>
      <div class="flex flex-col items-center text-slate-300">
        <span class="text-lg">📅</span>
        <span class="text-[10px] font-bold">Riwayat</span>
      </div>
      <div class="flex flex-col items-center text-slate-300">
        <span class="text-lg">👤</span>
        <span class="text-[10px] font-bold">Profil</span>
      </div>
    </nav> -->
  </div>
</template>

<script src="./main-page.js"></script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
</style>